import React, { useState } from 'react'

const Footer = () => {
  const [data] = useState({
    image: "/img/taco_bgwhite.png",
    b12Logo: '/img/b12logogray.png',
    hycLogo: '/img/logoHyCgray.png',
    socialMedia: [
      /*{ 
        iconClass: "fa fa-facebook",
        link: "https://www.facebook.com/cajapopular.tuc"
      }*/
    ]
  });

  return(
    <footer className="footer-section ptb-60" style={ { backgroundColor: 'black' } }>
      <div className="footer-wrap">
        <div className="container">

          <div className="row"> 
            <div className="col-md-6 col-lg-6" style={ { display: 'flex', alignItems: 'center', flexDirection: 'row' } }> 
                <img src={ data.image } alt="logo" style={ { height: 40, width: 40, marginRight: 10 } } />
                <p className="copyright">
                  Copyright 2022 © <img src={ data.hycLogo } alt="hyc" style={{height: 15}}/> <img src={ data.b12Logo } alt="b12" style={{height: 15}}/>
                </p>
            </div>
            <div className="col-md-6 col-lg-6" style={ { display: 'flex', justifyContent: 'flex-end', alignItems: 'center' } }> 
              {data.socialMedia?.length > 0 &&
                <ul className="list-inline">
                  <li>Siguenos en :</li>
                  { data.socialMedia.map((item, idx) => (
                    <li key={`fo_${idx}`}><a href={ item.link } target="_blank"> <i className={item.iconClass}></i></a></li>
                  )) }
                </ul>
              }
            </div>
          </div>

        </div>
      </div>
    </footer>
  )
}

export default Footer